import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar'
import { stringToColour } from '../../../app/utils/changeBackgroundColorOfInitials'
import { getNameInitial } from '../../../app/utils/getNameInitial'

export const BasicAvatar = ({
  profileImageUrl,
  name,
}: {
  profileImageUrl: string | undefined
  name: string | undefined
}) => {
  return (
    <Avatar>
      <AvatarImage
        src={
          profileImageUrl
            ? `${import.meta.env.VITE_CDN_URL}${profileImageUrl}`
            : ''
        }
      />
      <AvatarFallback
        style={{
          backgroundColor: `${stringToColour(name ?? '')}`,
        }}
      >
        {getNameInitial(name ?? '')}
      </AvatarFallback>
    </Avatar>
  )
}
